import { render, staticRenderFns } from "./template_codes.vue?vue&type=template&id=38fa4a98&scoped=true&"
import script from "./template_codes.vue?vue&type=script&lang=js&"
export * from "./template_codes.vue?vue&type=script&lang=js&"
import style0 from "./template_codes.vue?vue&type=style&index=0&id=38fa4a98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa4a98",
  null
  
)

export default component.exports